import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness';
import ModeNightIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import sty from '../styles/Prefer.module.css';
import { func, string } from 'prop-types';

/**
 * @component ThemeContent
 * @param {Object} props
 * @param {string} props.mode
 * @param {function} props.onMode
 * @returns {JSX.Element}
 */
function ThemeContent({ mode, onMode }) {
	return (
		<Box className={sty.tc_container}>
			<SettingsBrightnessIcon color="primary" fontSize="large" />
			<Typography className={sty.tc_typography} variant="body1">
				Theme
			</Typography>
			<ToggleButtonGroup
				className={sty.tc_toggleBtnGroup}
				exclusive
				value={mode}
				onChange={(e) => onMode(e.target.value)}>
				<ToggleButton className={sty.tc_toggleBtn} value="dark">
					<ModeNightIcon color="primary" />
					DARK
				</ToggleButton>
				<ToggleButton className={sty.tc_toggleBtn} value="light">
					<LightModeIcon color="warning" />
					LIGHT
				</ToggleButton>
			</ToggleButtonGroup>
		</Box>
	);
}

ThemeContent.propTypes = {
	mode: string,
	onMode: func,
};

export default ThemeContent;
